
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { MedewerkerFormValues } from "./types";

interface PersonalInfoFieldsProps {
  form: UseFormReturn<MedewerkerFormValues>;
}

const PersonalInfoFields = ({ form }: PersonalInfoFieldsProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="naam"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Naam</FormLabel>
            <FormControl>
              <Input {...field} placeholder="Volledige naam" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="roepnaam"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Roepnaam</FormLabel>
            <FormControl>
              <Input {...field} placeholder="Bijv. Rick" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="username"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Gebruikersnaam</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Gebruikersnaam voor inloggen" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="functie"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Functie</FormLabel>
            <FormControl>
              <Input {...field} placeholder="Functietitel" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="afdeling"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Afdeling</FormLabel>
            <FormControl>
              <Input {...field} placeholder="Afdelingsnaam" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Email</FormLabel>
            <FormControl>
              <Input {...field} type="email" placeholder="naam@luijtenvvz.nl" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default PersonalInfoFields;
